module.exports = __webpack_public_path__ + "static/media/28.f07a6c2c.jpg";